import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=56e5cc8a&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=56e5cc8a&lang=less&scoped=true&"
import style1 from "./MainHeader.vue?vue&type=style&index=1&id=56e5cc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5cc8a",
  null
  
)

export default component.exports